import React from 'react'
import s from './class-card.module.scss'
import classNames from 'classnames'
import { AnimatedCard } from '@shared/ui/animated-card/animated-card'
import { useAppointmentModal } from '@features/appointment/appointment/model/useAppointmentModal'
import { TZDate } from '@date-fns/tz'
import { queryClient } from '@shared/api/query-client'
import { TextWithEmoji } from '@shared/ui/text-with-emoji/text-with-emoji'

export const ClassCard = ({student, teacher, isUpcoming, isTeacher, starts_at, instrument, has_new_homework, has_unreviewed_homework, id}) => {
	const {data: profile} = queryClient.getQueryData(['profile'])
	
	const date = new TZDate(starts_at, profile?.timezone)
	const {open: openModal} = useAppointmentModal()
	const payed = true

	return (
		<AnimatedCard layoutId={starts_at}>	
			<div className={classNames(s.wrapper, isUpcoming ? s.upcoming : '')} onClick={() => openModal({appointmentId: id})}>
				{!payed ? <div className={s.badge}>Не оплачено</div> : ''}
				<div className={s.time}>
						{date.getHours() + ':' + (date.getMinutes()?.toString()?.padStart(2, '0'))}
				</div>
				<div className={s.content}>
					<span className={s.instrument} title={instrument?.name}><TextWithEmoji text={instrument?.name}/></span>
					{isTeacher ? 
					<div className={s.teacher}>
						<div className={s.avatar}>
							<img src={student?.avatar ? process.env.REACT_APP_STORAGE_URL + student?.avatar?.image : process.env.REACT_APP_STORAGE_URL + 'images/default_avatar.png'} alt="" />
						</div>
						<span>{student?.name}</span>
					</div> :
					<div className={s.teacher}>
						<div className={s.avatar}>
							<img src={teacher?.avatar ? process.env.REACT_APP_STORAGE_URL + teacher?.avatar?.image : process.env.REACT_APP_STORAGE_URL + 'images/default_avatar.png'} alt="" />
						</div>
						<span>{teacher?.name}</span>
					</div>
					}
				</div>
				{isTeacher ? (
					has_unreviewed_homework ? <span className={s.unread}></span> : ''
				) : (
					has_new_homework ? <span className={s.unread}></span> : ''
				)}
			</div>
		</AnimatedCard>
	)
}
